import axios from "axios";
import authHeader from "./auth-header";
import getmainurl from "./tools.service";

// current heats selection persisted server-side (restored on refresh)
const getSelection = async () => {
    return await axios({
        url: getmainurl() + '/api/v1/heats/selection', method: 'get', headers: authHeader()
    }).catch(function (error) {
        console.log(error.response ? error.response.data : error.message);
    })
}

const setSelection = async (data) => {
    return await axios({
        url: getmainurl() + '/api/v1/heats/selection', method: 'post', headers: authHeader(), data: data
    }).catch(function (error) {
        console.log(error.response ? error.response.data : error.message);
    })
}

const heats = {
    getSelection,
    setSelection,
};

export default heats;
